import {
  ClipboardDocumentListIcon,
  CurrencyDollarIcon,
  DocumentMagnifyingGlassIcon,
  LightBulbIcon,
} from '@heroicons/vue/24/outline'
import { inject } from 'vue'

export function useNavigation() {
  const route = inject('route')

  const navigation = [
    {
      name: 'Solutions',
      items: [
        {
          name: 'Bid Tabulations',
          description:
            'Up-to-date bid tab data to keep up with competition and price trends',
          href: '/#prediction',
          icon: ClipboardDocumentListIcon,
        },
        {
          name: 'AI Price Insights',
          description: 'Use advanced analytics to drive your bidding strategy',
          href: '/#prediction',
          icon: LightBulbIcon,
        },
        {
          name: 'Bidding & Estimating',
          description: 'Ditch spreadsheets and streamline your bidding process',
          href: '/#bidding',
          icon: CurrencyDollarIcon,
        },
        {
          name: 'Proposal Opportunity Tracking',
          description:
            'Quickly find and bid on the most profitable contracts for your business',
          href: '/#proposals',
          icon: DocumentMagnifyingGlassIcon,
        },
      ],
    },
    // {
    //   name: 'Who We Serve',
    //   items: [
    //     {
    //       name: 'General Contractors',
    //       description:
    //         'Consistently beat your competition by using their data against them',
    //       href: '#',
    //     },
    //     {
    //       name: 'Subcontractors',
    //       description:
    //         'Eliminate inefficiencies, maximize margins, and win more profitable work',
    //       href: '#',
    //     },
    //     {
    //       name: 'Engineers and Designers',
    //       description:
    //         'Confidently create engineering estimates and proposals using the latest data',
    //       href: '#',
    //     },
    //     {
    //       name: 'Agencies and Owners',
    //       description:
    //         'Gain visibility into recent pricing trends to justify budgets and minimize risk',
    //       href: '#',
    //     },
    //   ],
    // },
    {
      name: 'Pricing',
      href: route('marketing.pricing.index'),
    },
    // {
    //   name: 'Resources',
    //   items: [
    //     {
    //       name: 'States',
    //       description:
    //         'We have data in multiple states and are constantly expanding',
    //       href: '#',
    //     },
    //     {
    //       name: 'Pay Items',
    //       description: 'Search our database of pay items to find what you need',
    //       href: '#',
    //     },
    //     {
    //       name: 'Bid Tabulations',
    //       description: 'See the latest bid tabulations in your region',
    //       href: '#',
    //     },
    //   ],
    // },
    {
      name: 'Support',
      items: [
        {
          name: 'Contact Us',
          href: route('marketing.contact.index'),
        },
      ],
    },
  ]

  return { navigation }
}
